import { render, staticRenderFns } from "./RfidTokens.vue?vue&type=template&id=227d8a8c&lang=pug&"
import script from "./RfidTokens.vue?vue&type=script&lang=ts&"
export * from "./RfidTokens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports